export enum PatrimoineCategory {
  ValeurPatrimoineLoue = "valeur_patrimoine_loue",
  ValeurTerrainsNonLoues = "valeur_terrains_non_loues",
  ValeurLocativeTerrainsNonLoues = "valeur_locative_terrains_non_loues",
  ValeurImmoNonLoue = "valeur_immo_non_loue",
  ValeurLocativeImmoNonLoue = "valeur_locative_immo_non_loue",
  LivretA = "livret_a",
  EpargneRevenusNonImposables = "epargne_revenus_non_imposables",
  EpargneRevenusImposables = "epargne_revenus_imposables",
}
